import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Entity } from '@backstage/catalog-model';
import {
  catalogApiRef,
  EntityLoadingStatus,
  entityRouteRef,
} from '@backstage/plugin-catalog-react';
import {
  errorApiRef,
  useApi,
  useRouteRefParams,
} from '@backstage/frontend-plugin-api';
import useAsyncRetry from 'react-use/esm/useAsyncRetry';

export interface CustomEntityAnalyticsProviderPros {
  entity?: Entity;
  children?: React.ReactNode;
}

const CustomEntityAnalticsContext = createContext<EntityLoadingStatus>({
  loading: false,
});

export const useCustomEntityAnalytics = () => {
  return useContext(CustomEntityAnalticsContext);
};

export const CustomEntityProvider = (
  props: CustomEntityAnalyticsProviderPros,
) => {
  const { children } = props;

  const [state, setState] = useState<EntityLoadingStatus>({
    loading: false,
  });

  const navigate = useNavigate();
  const { kind, namespace, name } = useRouteRefParams(entityRouteRef);
  const errorApi = useApi(errorApiRef);
  const catalogApi = useApi(catalogApiRef);

  const {
    value: entity,
    error,
    loading,
    // retry: refresh,
  } = useAsyncRetry(
    async () => {
      if (!name) {
        return undefined;
      }
      return catalogApi.getEntityByRef({ kind, namespace, name });
    },
    [catalogApi, kind, namespace, name],
  );
  useEffect(() => {
    setState({ entity, error, loading });
  }, [entity, error, loading]);
  useEffect(() => {
    if (!name) {
      errorApi.post(new Error('No name provided!'));
      navigate('/');
    }
  }, [errorApi, navigate, error, loading, entity, name]);

  return (
    <CustomEntityAnalticsContext.Provider value={state}>
      {children}
    </CustomEntityAnalticsContext.Provider>
  );
};
